import { render } from "./UiMove.vue?vue&type=template&id=3e115dc5&scoped=true&lang=pug"
import script from "./UiMove.vue?vue&type=script&lang=js"
export * from "./UiMove.vue?vue&type=script&lang=js"

import "./UiMove.vue?vue&type=style&index=0&id=3e115dc5&lang=sass&scoped=true"

import exportComponent from "D:\\Front\\project\\valeriya.artist\\valeriya.artist.admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e115dc5"]])

export default __exports__